import { Box, Typography } from "@mui/material";
import DataThresholdingIcon from "@mui/icons-material/DataThresholding";

import CheckIcon from "../../../../Assets/Icons/check-icon.png";
import UncheckIcon from "../../../../Assets/Icons/uncheck-icon.png";

export const columns = [
  {
    field: "code",
    headerName: "Stock Code",
    width: 130,
  },
  {
    field: "description",
    headerName: "Description",
    width: 320,
    renderCell: (params) => (
      <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
        {params.value}
      </div>
    ),
  },
  {
    field: "active",
    headerName: "Active",
    width: 100,
    align: "center",
    type: "boolean",
    renderCell: (params) =>
      params.row.active === "Under Threshold" ? (
        <DataThresholdingIcon />
      ) : (
        <img
          src={params.row.active === "Active" ? CheckIcon : UncheckIcon}
          alt="Active icon"
        />
      ),
  },
  {
    field: "inventory",
    headerName: "Qty",
    width: 120,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => {
      const inventory = params.value;
      const threshold = params.row.thresholdValue;

      let color = "inherit";
      let warningText = "";
      let fontWeight = "normal";

      if (inventory === 0) {
        color = "error.main";
        warningText = "Out of stock";
        fontWeight = "bold";
      } else if (inventory < threshold) {
        color = "warning.main";
        warningText = "Getting low";
        fontWeight = "bold";
      }

      return (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography
            variant="body1"
            sx={{
              color,
              fontWeight,
            }}
          >
            {inventory}
          </Typography>
          {warningText && (
            <Typography
              variant="caption"
              sx={{
                color,
                display: "block",
                lineHeight: 1.2,
              }}
            >
              {`(${warningText})`}
            </Typography>
          )}
        </Box>
      );
    },
  },
  {
    field: "thresholdValue",
    headerName: "Threshold Value",
    width: 140,
    align: "center",
  },
  { field: "bayLocation", headerName: "Bay Location", width: 220 },
  { field: "lastSynced", headerName: "Last Synced", width: 220 },
];
